export function toFraction(value: number): string {
  const whole = Math.floor(value);
  const decimal = value - whole;

  const fractions: { decimal: number; display: string }[] = [
    { decimal: 0, display: '' },
    { decimal: 1 / 8, display: '1/8' },
    { decimal: 1 / 4, display: '1/4' },
    { decimal: 1 / 3, display: '1/3' },
    { decimal: 3 / 8, display: '3/8' },
    { decimal: 1 / 2, display: '1/2' },
    { decimal: 5 / 8, display: '5/8' },
    { decimal: 2 / 3, display: '2/3' },
    { decimal: 3 / 4, display: '3/4' },
    { decimal: 7 / 8, display: '7/8' },
    { decimal: 1, display: '1' }
  ];

  const nearest = fractions.reduce((prev, curr) =>
    Math.abs(curr.decimal - decimal) < Math.abs(prev.decimal - decimal) ? curr : prev
  );

  if (nearest.decimal === 1) return (whole + 1).toString();
  if (nearest.decimal === 0) return whole === 0 ? '0' : whole.toString();
  return whole > 0 ? `${whole} ${nearest.display}` : nearest.display;
}

export function parseFraction(value: string): number {
  const trimmed = value.trim();
  const parts = trimmed.split(' ');
  if (parts.length === 2) {
    const whole = parseFloat(parts[0]);
    const [n, d] = parts[1].split('/').map(Number);
    return whole + n / d;
  }
  const [n, d] = parts[0].split('/').map(Number);
  return d ? n / d : parseFloat(parts[0]);
}

export function scaleScalableHtml(html: string, scale: number): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Scale every .scalable span (ranges, allergy subs, multiple amounts per line)
  doc.querySelectorAll('.scalable').forEach((el) => {
    if (el.textContent) {
      el.textContent = toFraction(parseFraction(el.textContent) * scale);
    }
  });

  let result = doc.body.innerHTML;

  // Scale leftover {{amount}} from incomplete API conversion and strip brackets
  result = result.replace(/\{\{([^}]+)\}\}/g, (_, num: string) =>
    toFraction(parseFraction(num.trim()) * scale)
  );

  return result;
}
